import { useBgFormContext } from "@app/guranteeFormWrapper";
import { useStyles } from "@app/guranteeFormWrapper/styles";
import { FormInputMoney } from "@farzoom/common-ui-components";
import { BgFormInput } from "@utils/guaranteeForm/formShema";
import { Col } from "antd";
import { useEffect, useMemo } from "react";
import { useFormContext, useWatch } from "react-hook-form";

export const GuaranteeAmount = () => {
  const classes = useStyles();
  const { control, setValue } = useFormContext<BgFormInput>();
  const { prefix, isStartForm } = useBgFormContext();

  const currentPrefix = (prefix ? `${prefix}.guarantee` : "guarantee") as "guarantee";
  const lotsPrefix = prefix ? `${prefix}.purchase.lots` : "purchase.lots";

  const lots = useWatch({
    control,
    name: lotsPrefix as "purchase.lots",
  });

  const guaranteeAmount = useMemo(() => {
    if (!lots) return 0;

    return (lots || []).reduce((total, lot) => {
      return total + (lot.beneficiaries?.reduce((acc, b) => acc + (b.bgAmount ?? 0), 0) ?? 0);
    }, 0);
  }, [lots]);

  useEffect(() => {
    setValue(`${currentPrefix}.amount` as "guarantee.amount", guaranteeAmount);
  }, [guaranteeAmount]);

  if (isStartForm) return null;

  return (
    <Col span={12}>
      <FormInputMoney
        name={`${currentPrefix}.amount`}
        className={classes.input}
        control={control}
        setValue={setValue}
        label="Сумма гарантии"
        disabled
        maxLength={25}
      />
    </Col>
  );
};
